import React from "react";
import { Link } from "gatsby";
import { Offcanvas } from "react-bootstrap";
import { links } from "../../../data";

const Index = ({ isIndividualBlogPage, pageScrolled }) => {
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <Offcanvas show={open} onHide={() => setOpen(false)} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <Link
              className="navbar-brand logo-image my-3"
              to="/"
              role="button"
            />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="pt-2">
          <ul className="navbar-nav my-0 ms-auto">
            {links.map((link, index) => (
              <li className="nav-item p-2" key={index}>
                <Link
                  className={`nav-link fs-3 ${
                    isIndividualBlogPage ? "active" : ""
                  }`}
                  activeClassName="fw-bold"
                  to={link.to}
                >
                  {link.title}
                </Link>
              </li>
            ))}
          </ul>
        </Offcanvas.Body>
      </Offcanvas>

      <button
        onClick={() => setOpen(!open)}
        className={`btn fs-3 px-2 pb-1 border-0 ${
          pageScrolled === true
            ? "text-black"
            : pageScrolled === false
              ? "text-white"
              : "text-black"
        }`}
        aria-label="open-menu-btn"
      >
        <i className="fas fa-bars" />
      </button>
    </React.Fragment>
  );
};

export default Index;
